import { Link } from "react-router-dom";
import { channels, articles } from "@/mocks/articles";

const values = [
  { icon: "ri-compass-3-line", text: "看得更透" },
  { icon: "ri-focus-2-line", text: "挖得更深" },
  { icon: "ri-shield-check-line", text: "吃得理性" },
  { icon: "ri-lightbulb-line", text: "保持好奇" },
];

export default function AboutTeaser() {
  const pick = articles[articles.length - 1];
  return (
    <section className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
        <div className="lg:col-span-7">
          <span className="inline-flex items-center gap-1.5 text-xs tracking-[0.2em] text-primary-600 font-medium">
            <i className="ri-newspaper-line"></i>
            ABOUT 编辑部
          </span>
          <h2 className="mt-3 font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-tight">
            我们把"吃瓜"当成一件
            <span className="text-primary-600">需要下功夫</span>的事
          </h2>
          <p className="mt-5 max-w-2xl text-[15px] leading-8 text-foreground-600">
            在线吃瓜诞生于一群不爱看热闹、更爱看门道的编辑之手。我们相信，明星动态不是八卦流水账，小道消息不该被当成定论，
            未删细节与隐藏线索里藏着行业真实的运转逻辑。所以我们把镜头调近、把时间线拉长，用整理、比对与克制的方式，
            帮你把每一个瓜吃得比旁人更透更深。
          </p>
          <div className="mt-6 flex flex-wrap gap-2.5">
            {values.map((v) => (
              <span key={v.text} className="inline-flex items-center gap-2 px-3.5 py-2 rounded-full bg-accent-100 text-accent-900 text-sm">
                <i className={`${v.icon}`}></i>
                {v.text}
              </span>
            ))}
          </div>
          <div className="mt-7 flex flex-wrap gap-3">
            <Link to="/about" className="inline-flex items-center gap-2 whitespace-nowrap px-5 py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors">
              认识编辑部
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link to={`/article/${pick.id}`} className="inline-flex items-center gap-2 whitespace-nowrap px-5 py-2.5 rounded-lg border border-background-300 text-foreground-700 text-sm font-medium hover:border-primary-400 hover:text-primary-700 transition-colors">
              先尝一口最近的瓜
            </Link>
          </div>
        </div>

        <aside className="lg:col-span-5">
          <div className="rounded-2xl border border-background-200 bg-background-100 p-5 md:p-6">
            <p className="text-xs text-foreground-500 mb-4 flex items-center gap-1.5">
              <i className="ri-archive-2-line text-primary-500"></i>
              四个栏目，四种吃法
            </p>
            <div className="space-y-2.5">
              {channels.map((c) => (
                <Link key={c.id} to={`/channel/${c.id}`} className="group flex items-center justify-between px-4 py-3 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors">
                  <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-700">{c.name}</span>
                  <span className="flex items-center gap-1.5 text-xs text-foreground-500">
                    {c.en}
                    <i className="ri-arrow-right-s-line group-hover:translate-x-0.5 transition-transform"></i>
                  </span>
                </Link>
              ))}
            </div>
          </div>
        </aside>
      </div>
    </section>
  );
}